import { useMemo } from 'react';
import Box from '@mui/material/Box';
import { buildQrVector } from '../../utils/qr';
import { cardColors } from './cardTokens';

interface GuideCardQrCodeProps {
  /** URL to encode — must be the guide's canonical public identity URL. */
  value: string;
  /** CSS size of the square, quiet zone included. */
  size: string;
}

export function GuideCardQrCode({ value, size }: GuideCardQrCodeProps) {
  const qr = useMemo(() => {
    try {
      return buildQrVector(value);
    } catch {
      return null;
    }
  }, [value]);

  if (!qr) {
    return (
      <Box
        role="img"
        aria-label="QR code unavailable"
        data-qr-error="true"
        sx={{
          width: size,
          height: size,
          display: 'grid',
          placeItems: 'center',
          textAlign: 'center',
          color: cardColors.muted,
          fontSize: '0.6em',
        }}
      >
        QR unavailable
      </Box>
    );
  }

  return (
    <svg
      role="img"
      aria-label={`QR code linking to ${value}`}
      data-qr-value={value}
      viewBox={`0 0 ${qr.viewBoxSize} ${qr.viewBoxSize}`}
      shapeRendering="crispEdges"
      style={{ width: size, height: size, display: 'block' }}
    >
      <rect width={qr.viewBoxSize} height={qr.viewBoxSize} fill={cardColors.white} />
      <path d={qr.path} fill={cardColors.navy} />
    </svg>
  );
}
